import type { ApiErrorInput } from './ApiError'
import ApiError from './ApiError'

function get409MessageError(message: string, detail: any): string {
  if (message === 'ValidationError') {
    return detail.__all__ ?? ''
  }
  if (message === 'ProtectedError') {
    return `This object is used by another resource, you cannot delete it`
  }
  return message
}

function get422MessageError(detail: any): string {
  if (!Array.isArray(detail) || detail.length === 0) {
    return 'Unknown Error'
  }
  return detail.slice(0, 3).map(({ loc, msg }) => `${loc?.join('.')}: ${msg}`).join(', ')
}

function getHinokuniFallbackErrorMessage({ body, status }: ApiErrorInput): string {
  switch (status) {
    case 402:
      return 'Payment Required'
    case 404:
      return 'Not Found'
    case 423:
      return 'This object is locked, you are not allowed to make any changes'
    case 422:
      return get422MessageError(body?.detail)
    case 400:
    case 409:
    default:
      return 'Unknown Error'
  }
}

function getHinokuniErrorMessage({ body, status }: ApiErrorInput): string | undefined {
  switch (status) {
    case 400:
    case 409:
      return get409MessageError(body.message, body.detail)
    case 401:
      return 'Unauthorized'
    case 402:
      return body.message
    case 403:
      return body.message ?? 'Forbidden'
    case 404:
      return body.message
    case 422:
      // it's a form error, getChildren will handle this
      return undefined
    case 423:
      return body.message
    case 429:
      return 'You have tried this too many times, please retry later'
    case 500:
      return 'Internal Server Error'
    default:
      return undefined
  }
}

export default class HinokuniError extends ApiError {
  constructor(error: ApiErrorInput) {
    super(error, getHinokuniErrorMessage, getHinokuniFallbackErrorMessage)
  }

  getChildren(): Record<string, Error> {
    const errors: Record<string, Error> = {}
    if (this.status === 400 && this.body.message === 'ValidationError') {
      // I don't think it will happen
      // django validation error
      for (const key in this.body.detail) {
        if (key === '__all__') {
          continue
        }
        errors[key] = new Error(this.body.detail[key])
      }
    }
    else if (this.status === 422 && Array.isArray(this.body.detail)) {
      // pydantic validation error
      for (const error of this.body.detail) {
        const key = error.loc.at(-1)
        errors[key] = new Error(error.msg)
      }
    }
    return errors
  }
}
